const articleDropdown = document.querySelector('.article-filter-selector');
if (articleDropdown) {
    articleDropdown.addEventListener('change', () => {
        let newUrl = articleDropdown.dataset.hubUrl + '/';
        if (articleDropdown.value !== '') {
            newUrl = newUrl + '?category=' + articleDropdown.value;
        }

        window.location.href = newUrl;
    });
}